var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "py-1 px-3 border-b border-slate-400",
      attrs: { id: "room-section" }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex items-center justify-between px-3 py-2 mb-1 cursor-pointer",
          attrs: { title: _vm.title },
          on: {
            click: function($event) {
              _vm.chevronOpened = !_vm.chevronOpened
            }
          }
        },
        [
          _c("BlTextSubtitle3", {
            staticClass: "text-slate-600 truncate",
            attrs: { text: _vm.title }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex items-center gap-2" },
            [
              _c("BlBubbleCount", { attrs: { count: _vm.rooms.length || 0 } }),
              _vm._v(" "),
              _c("BlIcon", {
                staticClass: "w-4 h-4 transition-all duration-300",
                style: _vm.chevronOpened
                  ? { rotate: "0deg" }
                  : { rotate: "180deg" },
                attrs: { icon: "chevron-up" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.chevronOpened
        ? _c(
            "div",
            { staticClass: "flex flex-col gap-1" },
            [
              _vm.title === "No branch" &&
              _vm.currentUser.role.includes("admin")
                ? _c(
                    "div",
                    { staticClass: "py-2 px-4 rounded bg-cornflower-200" },
                    [
                      _c("BlTextBody2", {
                        staticClass: "text-cornflower-800 flex-wrap",
                        attrs: { text: "New branch needed? Create it in" }
                      }),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass: "flex items-center gap-1",
                          attrs: {
                            to: "/repository?tab=branch",
                            target: "_blank"
                          }
                        },
                        [
                          _c("BlTextBody2", {
                            staticClass:
                              "text-cornflower-800 flex-wrap font-bold underline",
                            attrs: { text: "Repository." }
                          }),
                          _vm._v(" "),
                          _c("BlIcon", {
                            staticClass: "h-4 w-4",
                            attrs: { icon: "square-up", color: "cornflower-8" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.rooms, function(room) {
                return _c("RoomItem", {
                  key: room.id,
                  attrs: {
                    room: room,
                    isActive: _vm.selectedRoomId === room.id
                  },
                  on: {
                    "change-select": function($event) {
                      return _vm.$emit("select-room", $event)
                    }
                  }
                })
              })
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27db4b3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27db4b3a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/availabilities/room/GroupBranch.vue
// module id = null
// module chunks = 